import React from 'react'
import { connect } from 'react-redux'
import StripePluginModal from '../components/stripe-plugin-modal/index'

const mapStateToProps = (state) => ({
  ...state.stripePluginModal
})

export default connect(mapStateToProps)(StripePluginModal)
